var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notifications',{attrs:{"max":3,"width":300,"position":"top center"}}),_c('v-main',[_c('router-view',{staticClass:"content"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }